/* Shade Studios — Finder UI (Suche 2.0). Braucht finder.js (window.ShadeFinder). */
(function () {
  'use strict';
  var F = window.ShadeFinder;
  if (!F) return;
  /* AUDIT C3 27.10.2026: /en bekommt englische Texte und Links mit /en (vorher fiel die Suche ins Deutsche) */
  var EN = /^\/en(\/|$)/.test(location.pathname);
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function T(de, en) { return EN ? en : de; }

  var SCHUH = ['36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47'];
  var KLEID = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];
  var PREISE = [100, 150, 200, 300, 500];

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function eur(n) { return String(n).replace('.', ',') + ' €'; }
  function onSearchPage() { return /\/search\/?$/.test(location.pathname); }
  function onCollectionPage() { return /^(\/[a-z]{2}(-[a-z]{2})?)?\/collections\/[^\/]+\/?$/.test(location.pathname); }
  function onFinderPage() { return onSearchPage() || onCollectionPage(); }
  function emptyP() { return { sizes: [], clothes: [], sofort: false, pmin: null, pmax: null, words: [], vendor: '', colors: [], sku: '' }; }
  function clone(p) { return JSON.parse(JSON.stringify(p)); }

  function sizeLabel(p) {
    var all = p.sizes.slice().sort(function (a, b) { return parseFloat(a) - parseFloat(b); });
    all = all.map(F.fmtLabel);
    if (all.length > 3) return T('Größe ', 'Size ') + all[0] + '–' + all[all.length - 1];
    return T('Größe ', 'Size ') + all.concat(p.clothes).join(', ');
  }
  function chips(p) {
    var c = [];
    if (p.sizes.length) c.push({ k: 'sizes', t: sizeLabel(p) });
    else if (p.clothes.length) c.push({ k: 'clothes', t: T('Größe ', 'Size ') + p.clothes.join(', ') });
    if (p.sofort) c.push({ k: 'sofort', t: T('Sofort verfügbar', 'In stock now'), ok: true });
    if (p.pmin != null && p.pmax != null) c.push({ k: 'preis', t: eur(p.pmin) + ' – ' + eur(p.pmax) });
    else if (p.pmax != null) c.push({ k: 'preis', t: T('bis ', 'up to ') + eur(p.pmax) });
    else if (p.pmin != null) c.push({ k: 'preis', t: T('ab ', 'from ') + eur(p.pmin) });
    return c;
  }
  function go(st) { location.href = F.toUrl(st); }
  /* Direktaufruf /search?q=jordan+4 (Google, Link, Adressleiste): nie die native OR-Suche zeigen */
  (function () {
    if (!onSearchPage()) return;
    var sp = new URLSearchParams(location.search), q = (sp.get('q') || '').trim();
    if (!q || q === '*' || sp.get('fq') || /(?:^|\s)(?:title|vendor):/.test(q)) return;
    var p = merge(emptyP(), F.parse(q));
    if (!p.words.length && !p.vendor && !p.sizes.length && !p.clothes.length && !p.sofort && p.pmin == null && p.pmax == null && !p.sku) return;
    location.replace(F.toUrl({ parsed: p, sort: sp.get('sort_by') || '' }));
  })();
  function without(st, k) {
    var s = clone(st); var p = s.parsed;
    if (k === 'sizes' || k === 'clothes') { p.sizes = []; p.clothes = []; }
    if (k === 'sofort') p.sofort = false;
    if (k === 'preis') { p.pmin = null; p.pmax = null; }
    if (k === 'modell') { p.modell = []; }
    s.fallback = false;
    return s;
  }
  function merge(base, add) {
    var p = clone(base);
    if (add.sizes.length || add.clothes.length) { p.sizes = add.sizes; p.clothes = add.clothes; }
    if (add.sofort) p.sofort = true;
    if (add.pmin != null) p.pmin = add.pmin;
    if (add.pmax != null) p.pmax = add.pmax;
    p.words = add.words; p.vendor = add.vendor; p.colors = add.colors; p.sku = add.sku;
    return p;
  }

  /* ---------- 1) Eingaben abfangen (Header-Suche + Suchseite) ---------- */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.id === 'facet-form' || f.getAttribute('is') === 'facet-form') return;
    var a;
    try { a = new URL(f.action, location.href); } catch (x) { return; }
    if (!/\/search\/?$/.test(a.pathname)) return;
    var inp = f.querySelector('input[name="q"]');
    if (!inp) return;
    var text = inp.value || '';
    if (!text.trim() && !onSearchPage()) return;
    e.preventDefault();
    e.stopPropagation();
    var p = merge(emptyP(), F.parse(text)); // neue Suche = frische Filter
    if (!p.words.length && !p.vendor && !p.sizes.length && !p.clothes.length && !p.sofort && p.pmin == null && p.pmax == null) {
      return; // leere Eingabe
    }
    go({ parsed: p, sort: onSearchPage() ? F.fromLocation(location).sort : '' });
  }, true);

  /* Vorladen: Tipp-Pause (350 ms) -> HTML der Zielseite vorab holen, Enter laedt dann ohne Wartezeit.
     AUDIT 27.10.2026: prefetch statt prerender - kein Ausfuehren von Skripten/Pixeln einer unsichtbaren Seite. */
  (function () {
    if (!HTMLScriptElement.supports || !HTMLScriptElement.supports('speculationrules')) return;
    var t, last = '', tag;
    document.addEventListener('input', function (e) {
      var inp = e.target;
      if (!inp || inp.name !== 'q' || !inp.form) return;
      var a;
      try { a = new URL(inp.form.action, location.href); } catch (x) { return; }
      if (!/\/search\/?$/.test(a.pathname)) return;
      clearTimeout(t);
      t = setTimeout(function () {
        var text = (inp.value || '').trim();
        if (text.length < 3) return;
        var p = merge(emptyP(), F.parse(text));
        if (!p.words.length && !p.vendor) return;
        var u = F.toUrl({ parsed: p, sort: onSearchPage() ? F.fromLocation(location).sort : '' });
        if (u === last) return;
        last = u;
        if (tag) tag.remove();
        tag = document.createElement('script');
        tag.type = 'speculationrules';
        tag.textContent = JSON.stringify({ prefetch: [{ urls: [u], eagerness: 'immediate' }] });
        document.head.appendChild(tag);
      }, 350);
    }, true);
  })();

  /* ---------- 2) Vorschlags-Suche: Wörter statt Größe/Preis schicken ---------- */
  /* AUDIT 27.10.2026: erst ersetzen, wenn ein Suchfeld den Fokus bekommt - vorher bleibt fetch unangetastet */
  var origFetch = window.fetch;
  function fetchErsetzen(e) {
    var t = e && e.target;
    if (!t || t.name !== 'q') return;
    document.removeEventListener('focusin', fetchErsetzen, true);
    document.removeEventListener('input', fetchErsetzen, true);
    if (!origFetch || window.fetch.__finder) return;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url);
        if (url && url.indexOf('/search/suggest') > -1) {
          var x = new URL(url, location.origin);
          var qv = x.searchParams.get('q');
          if (qv) {
            var p = F.parse(qv);
            var nq = F.looseQuery(p);
            if (nq.trim()) {
              x.searchParams.set('q', nq);
              input = x.pathname + x.search;
            }
          }
        }
      } catch (err) { /* ignorieren */ }
      return origFetch.call(this, input, init);
    };
    window.fetch.__finder = true;
  }
  document.addEventListener('focusin', fetchErsetzen, true);
  document.addEventListener('input', fetchErsetzen, true);
  if (document.activeElement && document.activeElement.name === 'q') fetchErsetzen({ target: document.activeElement });

  /* ---------- 3) „Verstanden“-Zeile unter jedem Suchfeld ---------- */
  function hintFor(input) {
    var wrap = input.closest('.search-input');
    if (!wrap) return;
    var hint = wrap.parentNode.querySelector(':scope > .finder-hint');
    if (!hint) {
      hint = document.createElement('div');
      hint.className = 'finder-hint';
      hint.setAttribute('aria-live', 'polite');
      wrap.insertAdjacentElement('afterend', hint);
    }
    var v = input.value.trim();
    if (!v) { hint.innerHTML = ''; return; }
    var p = F.parse(v);
    var cs = chips(p);
    if (!cs.length) { hint.innerHTML = ''; return; }
    hint.innerHTML = '<span class="finder-hint__lead">' + T('Verstanden:', 'Searching for:') + '</span>' + cs.map(function (c) {
      return '<span class="finder-chip finder-chip--on' + (c.ok ? ' finder-chip--ok' : '') + '">' + esc(c.t) + '</span>';
    }).join('');
  }
  function wireInputs() {
    document.querySelectorAll('form[role="search"] input[name="q"], .search-input input[name="q"]').forEach(function (inp) {
      if (inp.__finder) return;
      inp.__finder = true;
      inp.addEventListener('input', function () { hintFor(inp); });
      inp.addEventListener('focus', function () { hintFor(inp); });
      hintFor(inp);
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-example]');
    if (!b) return;
    var form = b.closest('form');
    var inp = form && form.querySelector('input[name="q"]');
    if (inp) { inp.value = b.getAttribute('data-example'); inp.focus(); hintFor(inp); }
  });


  /* ---------- Farbe / Kategorie / Modell: Werte aus den Karten, Zustand in der URL ---------- */
  var FARB_HEX = { 'Schwarz': '#111', 'Weiß': '#fff', 'Grau': '#9a9aa3', 'Beige': '#d8c7a6', 'Braun': '#7a5230', 'Rot': '#d03a3a',
    'Pink': '#f08bb4', 'Orange': '#f08a24', 'Gelb': '#f2cf2e', 'Grün': '#3f9b5a', 'Blau': '#3a6fd8', 'Lila': '#8a58c9' };
  var FARB_ORDER = ['Schwarz', 'Weiß', 'Grau', 'Beige', 'Braun', 'Rot', 'Pink', 'Orange', 'Gelb', 'Grün', 'Blau', 'Lila'];
  var KAT_ORDER = ['Herren', 'Damen', 'Kids'];
  function collect() {
    var c = { farbe: {}, kat: {}, modell: {} };
    if (modelPool) { c.modell = modelPool; return c; }
    document.querySelectorAll('.finder-hit').forEach(function (h) {
      var m = h.getAttribute('data-model');
      if (m) c.modell[m] = (c.modell[m] || 0) + 1;
    });
    return c;
  }
  function renderExtra() {
    var sp = new URLSearchParams(location.search);
    var c = collect();
    document.querySelectorAll('[data-finder-extra]').forEach(function (host) {
      var uid = host.closest('form') ? (host.closest('form').getAttribute('section-id') || 'f') : 'f';
      function sect(title, key, vals, order, kind) {
        var names = Object.keys(vals);
        sp.getAll(key).forEach(function (a) { if (names.indexOf(a) < 0) names.push(a); });
        if (!names.length) return '';
        names.sort(function (a, b) {
          if (order) { var ia = order.indexOf(a), ib = order.indexOf(b); return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib); }
          return (vals[b] || 0) - (vals[a] || 0) || a.localeCompare(b);
        });
        var act = sp.getAll(key);
        var inner = '';
        if (kind === 'color') {
          inner = '<div class="finder-swatches">' + names.map(function (n) {
            var on = act.indexOf(n) > -1;
            return '<label class="finder-sw" title="' + esc(n) + '"><input type="checkbox" autocomplete="off" name="' + key + '" value="' + esc(n) + '"' + (on ? ' checked' : '') + '>' +
              '<span class="finder-sw__dot" style="background:' + (FARB_HEX[n] || '#ccc') + '"></span><span class="finder-sw__name">' + esc(n) + '</span><em>' + (vals[n] || '') + '</em></label>';
          }).join('') + '</div>';
        } else {
          var list = names.slice(0, kind === 'model' ? 40 : 10);
          inner = '<div class="finder-list">' + list.map(function (n) {
            var on = act.indexOf(n) > -1;
            return '<label class="finder-li"><input type="checkbox" autocomplete="off" name="' + key + '" value="' + esc(n) + '"' + (on ? ' checked' : '') + '><span>' + esc(n) + '</span></label>';
          }).join('') + '</div>';
        }
        return '<details class="finder-acc" ' + (kind === 'color' || kind === 'cat' || act.length ? 'open' : '') + '><summary>' + title + (act.length ? ' <b>' + act.length + '</b>' : '') + '</summary>' + inner + '</details>';
      }
      var html = ''; /* Modell-Filter entfernt (Pascal 16.10.) */
      if (host.__html !== html) { host.innerHTML = html; host.__html = html; }
    });
  }


  /* ---------- Preisregler: nicht-linear 0–1000 €, oben offen („1000+“) ---------- */
  function p2e(p) { return p <= 40 ? p * 5 : p <= 70 ? 200 + (p - 40) * 10 : Math.round((500 + (p - 70) * 500 / 30) / 10) * 10; }
  function e2p(v) { return v <= 200 ? Math.round(v / 5) : v <= 500 ? 40 + Math.round((v - 200) / 10) : Math.min(100, 70 + Math.round((v - 500) * 30 / 500)); }
  function fire(el) { el.dispatchEvent(new Event('input', { bubbles: true })); el.dispatchEvent(new Event('change', { bubbles: true })); }
  function initPrice() {
    document.querySelectorAll('.finder-price-ui').forEach(function (ui) {
      if (ui.__ready) return;
      ui.__ready = true;
      var lo = ui.querySelector('[data-fp-lo]'), hi = ui.querySelector('[data-fp-hi]');
      var nmin = ui.querySelector('[data-fp-nmin]'), nmax = ui.querySelector('[data-fp-nmax]');
      var grp = ui.querySelector('[data-fp-group]'), lab = ui.querySelector('[data-fp-label]');
      var q = new URLSearchParams(location.search);
      var a = q.get('filter.v.price.gte'), b = q.get('filter.v.price.lte');
      if (a) nmin.value = a; if (b) nmax.value = b;
      lo.value = a ? e2p(+a) : 0;
      hi.value = b ? e2p(+b) : 100;
      function paint() {
        var l = +lo.value, h = +hi.value;
        grp.style.setProperty('--range-min', l + '%');
        grp.style.setProperty('--range-max', h + '%');
        lab.textContent = (l === 0 ? '0' : p2e(l)) + T(' bis ', ' to ') + (h === 100 ? T('1.000+', '1,000+') : p2e(h)) + ' €';
        ui.querySelectorAll('[data-fp-preset]').forEach(function (b) { b.classList.toggle('is-on', l === 0 && h !== 100 && p2e(h) === +b.getAttribute('data-fp-preset')); });
      }
      function commit() {
        var l = +lo.value, h = +hi.value;
        nmin.value = l === 0 ? '' : p2e(l);
        nmax.value = h === 100 ? '' : p2e(h);
        fire(nmax.value !== '' ? nmax : nmin);
      }
      lo.addEventListener('input', function () { if (+lo.value > +hi.value) lo.value = hi.value; paint(); });
      hi.addEventListener('input', function () { if (+hi.value < +lo.value) hi.value = lo.value; paint(); });
      lo.addEventListener('change', commit);
      hi.addEventListener('change', commit);
      [nmin, nmax].forEach(function (n) {
        n.addEventListener('input', function () {
          var v = parseInt(n.value, 10);
          if (n === nmin) lo.value = isFinite(v) ? e2p(v) : 0; else hi.value = isFinite(v) ? e2p(v) : 100;
          paint();
        });
      });
      ui.addEventListener('click', function (e) {
        var bt = e.target.closest('[data-fp-preset]');
        if (!bt) return;
        var v = +bt.getAttribute('data-fp-preset');
        var same = nmax.value !== '' && +nmax.value === v && nmin.value === '';
        nmin.value = '';
        lo.value = 0;
        nmax.value = same ? '' : v;
        hi.value = same ? 100 : e2p(v);
        paint();
        fire(nmax);
      });
      paint();
    });
  }


  /* ---------- Filter-Spalte ein-/ausklappen (Desktop) ---------- */
  /* Standard: Filter-Spalte zu (mehr Platz für die Produkte). Offen, wenn der Kunde sie geöffnet hat oder ein Filter aktiv ist. */
  function facetsOff() {
    var v = null;
    try { v = localStorage.getItem('finderFacetsOff'); } catch (x) { /* egal */ }
    if (v === '0') return false;
    if (v === '1') return true;
    return !hasFilterParams();
  }
  function wireToggle() {
    var col = document.querySelector('.collection');
    var lab = document.querySelector('.collection__top-bar .text-with-icon');
    if (!col || !lab) return;
    document.documentElement.classList.toggle('finder-open', !facetsOff());
    if (lab.__tog) return;
    lab.__tog = true;
    lab.setAttribute('role', 'button');
    lab.setAttribute('tabindex', '0');
    lab.classList.add('finder-ftoggle');
    var sp = document.createElement('span');
    sp.className = 'finder-ftoggle__txt';
    lab.appendChild(sp);
    function isOff() { return !document.documentElement.classList.contains('finder-open'); }
    function paintT() { sp.textContent = isOff() ? T('einblenden', 'show') : T('ausblenden', 'hide'); lab.setAttribute('aria-expanded', isOff() ? 'false' : 'true'); }
    function flip() {
      var off = !isOff();
      document.documentElement.classList.toggle('finder-open', !off);
      try { localStorage.setItem('finderFacetsOff', off ? '1' : '0'); } catch (x) { /* egal */ }
      paintT();
    }
    lab.addEventListener('click', flip);
    lab.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); flip(); } });
    paintT();
  }


  /* ---------- Sofort-Umschalten: Filteränderungen ohne Server-Rundlauf ---------- */
  var LOCAL_SEL = '.finder-tile__input, input[data-finder-sofort], input[name="modell"], [data-fp-nmin], [data-fp-nmax]';
  function stateFromDom(root) {
    var sizes = [], modell = [];
    root.querySelectorAll('.finder-tile__input:checked').forEach(function (i) { if (sizes.indexOf(i.value) < 0) sizes.push(i.value); });
    root.querySelectorAll('input[name="modell"]:checked').forEach(function (i) { if (modell.indexOf(i.value) < 0) modell.push(i.value); });
    var sw = root.querySelector('input[data-finder-sofort]');
    var nmin = root.querySelector('[data-fp-nmin]'), nmax = root.querySelector('[data-fp-nmax]');
    return { sizes: sizes, modell: modell, sofort: !!(sw && sw.checked), pmin: nmin && nmin.value !== '' ? +nmin.value : null, pmax: nmax && nmax.value !== '' ? +nmax.value : null };
  }
  function writeUrl(d) {
    var sp = new URLSearchParams(location.search);
    Array.from(sp.keys()).forEach(function (k) { if (/^filter\.v\.(option|price)\./.test(k) || /^(sofort|modell|page|fb)$/.test(k)) sp.delete(k); });
    d.sizes.forEach(function (g) { sp.append('filter.v.option.größe', g); });
    if (d.pmin != null) sp.set('filter.v.price.gte', String(d.pmin));
    if (d.pmax != null) sp.set('filter.v.price.lte', String(d.pmax));
    if (d.sofort) sp.set('sofort', '1');
    d.modell.forEach(function (m) { sp.append('modell', m); });
    history.replaceState(null, '', location.pathname + '?' + sp.toString());
  }
  function syncInputs() {
    var sp = new URLSearchParams(location.search);
    var gids = sp.getAll('filter.v.option.größe'), mods = sp.getAll('modell');
    var rawKeys = gids.map(function (g) { return F.sizeKey(g); });
    document.querySelectorAll('.finder-tile__input').forEach(function (i) {
      var lbl = i.parentNode.querySelector('.finder-tile__box');
      var k = lbl ? F.sizeKey(lbl.getAttribute('data-raw') || lbl.textContent) : '';
      i.checked = gids.indexOf(i.value) > -1 || (k && rawKeys.indexOf(k) > -1);
    });
    document.querySelectorAll('input[data-finder-sofort]').forEach(function (i) { i.checked = sp.get('sofort') === '1'; });
    document.querySelectorAll('input[name="modell"]').forEach(function (i) { i.checked = mods.indexOf(i.value) > -1; });
    document.querySelectorAll('[data-fp-nmin]').forEach(function (i) { i.value = sp.get('filter.v.price.gte') || ''; });
    document.querySelectorAll('[data-fp-nmax]').forEach(function (i) { i.value = sp.get('filter.v.price.lte') || ''; });
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!onFinderPage() || !t || !t.matches || !t.matches(LOCAL_SEL)) return;
    var form = t.closest('form');
    if (!form) return;
    e.stopImmediatePropagation();
    e.preventDefault();
    // Größe gewählt → Sofort an (außer der Kunde hat es bewusst ausgeschaltet)
    /* Sofort wird NICHT mehr automatisch eingeschaltet (Pascal 16.10.) */
    if (t.matches('input[data-finder-sofort]')) {
      try { sessionStorage.setItem('finderSofortAus', t.checked ? '' : '1'); } catch (x) { /* egal */ }
    }
    writeUrl(stateFromDom(form));
    syncInputs();
    renderPriceFromUrl();
    window.dispatchEvent(new Event('finder:changed'));
  }, true);
  function renderPriceFromUrl() {
    var sp = new URLSearchParams(location.search);
    document.querySelectorAll('.finder-price-ui').forEach(function (ui) {
      var lo = ui.querySelector('[data-fp-lo]'), hi = ui.querySelector('[data-fp-hi]');
      if (!lo || !hi) return;
      var a = sp.get('filter.v.price.gte'), b = sp.get('filter.v.price.lte');
      lo.value = a ? e2p(+a) : 0; hi.value = b ? e2p(+b) : 100;
      lo.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }

  /* ---------- 4) Suchseite: schneller Index (JSON) + variantengenaue Treffer ---------- */
  var st = null;
  var modelPool = null;          // Modell → Anzahl (aus dem Index)
  var built = '';                // Signatur der zuletzt gebauten Trefferliste
  var token = 0;                 // verwirft veraltete Antworten
  var idxCache = {};

  function activeFilter(p) { return p.sizes.length || p.clothes.length || p.sofort || p.pmin != null || p.pmax != null || (p.farbe && p.farbe.length) || (p.kat && p.kat.length) || (p.modell && p.modell.length); }
  function resetKeys(k) { return /^filter\./.test(k) || /^(sofort|farbe|kat|modell|page|fb)$/.test(k); }
  function hasFilterParams() {
    var any = false;
    new URLSearchParams(location.search).forEach(function (v, k) { if (resetKeys(k) && k !== 'page' && k !== 'fb') any = true; });
    return any;
  }
  function resetUrl() {
    var sp = new URLSearchParams(location.search), out = new URLSearchParams();
    sp.forEach(function (v, k) { if (!resetKeys(k)) out.append(k, v); });
    return location.pathname + '?' + out.toString();
  }
  function renderReset() {
    var on = hasFilterParams();
    document.querySelectorAll('[data-finder-reset]').forEach(function (e) { if (!e.closest('.finder-status')) e.remove(); });
    if (!on) return;
    document.querySelectorAll('form#facet-form').forEach(function (f) {
      var r = document.createElement('a');
      r.href = resetUrl(); r.className = 'finder-reset finder-reset--form'; r.setAttribute('data-finder-reset', ''); r.textContent = T('Alle Filter zurücksetzen', 'Reset all filters');
      var box = f.querySelector('.facets-drawer__floating-apply');
      r.textContent = T('Filter zurücksetzen', 'Reset filters');
      (box || f).appendChild(r);
    });
    var lab = document.querySelector('.collection__top-bar .text-with-icon');
    if (lab && lab.parentNode) {
      var a = document.createElement('a');
      a.href = resetUrl(); a.className = 'finder-reset'; a.setAttribute('data-finder-reset', ''); a.textContent = T('Filter zurücksetzen', 'Reset filters');
      lab.parentNode.insertBefore(a, lab.nextSibling);
    }
  }

  /** Index-URL: gleiche Suche, nur Ansicht „finder“ (kompaktes JSON, 250 je Seite) */
  function indexUrl(page) {
    var sp = new URLSearchParams(location.search);
    ['page', 'view', 'sort_by', 'sofort', 'farbe', 'kat', 'modell', 'fq', 'fb'].forEach(function (k) { sp.delete(k); });
    Array.from(sp.keys()).forEach(function (k) { if (/^filter\.v\.(option|price)\./.test(k)) sp.delete(k); });
    if (onSearchPage()) sp.set('type', 'product');
    sp.set('view', 'finder');
    sp.set('page', String(page));
    return location.pathname + '?' + sp.toString();
  }
  function getJson(u) {
    return fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (t) { return JSON.parse(t); });
  }
  function loadIndex() {
    var key = indexUrl(1);
    if (idxCache[key]) return Promise.resolve(idxCache[key]);
    // Suche: höchstens 1.000 Treffer = 4 Seiten gleichzeitig. Kollektion: 6 Seiten gleichzeitig, Rest nachladen.
    var first = onSearchPage() ? 4 : 6;
    var reqs = [];
    for (var pg = 1; pg <= first; pg++) reqs.push(getJson(indexUrl(pg)).catch(function () { return { items: [], total: 0, pages: 1 }; }));
    return Promise.all(reqs).then(function (rs) {
      var pages = rs[0].pages || 1, more = [];
      for (var q = first + 1; q <= Math.min(pages, 30); q++) more.push(getJson(indexUrl(q)).catch(function () { return { items: [] }; }));
      return Promise.all(more).then(function (ms) {
        var seen = {}, items = [];
        rs.concat(ms).forEach(function (r) { (r.items || []).forEach(function (it) { if (!seen[it.h]) { seen[it.h] = 1; items.push(it); } }); });
        return (idxCache[key] = { total: rs[0].total || items.length, items: items });
      });
    });
  }

  function lieferInfo() {
    document.querySelectorAll('.finder-hit .h-verfuegbar').forEach(function (el) {
      el.style.display = /besorgt|werktage|ordered in|working days/i.test(el.textContent || '') ? 'none' : '';
    });
  }
  function setH1(n, p, more) {
    if (!onSearchPage()) return;
    var tt = ((p.vendor ? p.vendor + ' ' : '') + p.words.join(' ')).trim();
    if (tt) document.title = T('Suche: ', 'Search: ') + tt + ' – Shade Studios';
    var h1 = document.querySelector('main h1, h1.h2');
    var tx = ((p.vendor ? p.vendor + ' ' : '') + p.words.join(' ')).trim();
    if (h1) h1.textContent = n === 0 ? T('Keine passenden Treffer', 'No matching results') : n + (more ? '+' : '') + T(' passende Treffer', ' matching results') + (tx ? T(' für „' + tx + '“', ' for "' + tx + '"') : '');
  }
  function statusEl() {
    var e = document.querySelector('[data-finder-status]');
    if (!e && onCollectionPage()) {
      var l = document.querySelector('product-list');
      if (l && l.parentNode) { e = document.createElement('p'); e.className = 'finder-status'; e.setAttribute('data-finder-status', ''); l.parentNode.insertBefore(e, l); }
    }
    return e;
  }

  /** Aussage zu den GEWÄHLTEN Größen dieses Produkts (statt grauem Block) */
  function sizeInfo(vs, p) {
    var sel = p.sizes.concat(p.clothes);
    function has(v, k) { return v.key === k; }
    var present = [], soforts = [];
    sel.forEach(function (k) {
      var av = vs.filter(function (v) { return v.avail && has(v, k); });
      if (av.length) { present.push(k); if (av.some(function (v) { return v.sofort; })) soforts.push(k); }
    });
    var prices = [];
    vs.forEach(function (v) { if (v.avail && sel.some(function (k) { return has(v, k); }) && (!p.sofort || v.sofort)) prices.push(v.price); });
    var lo = Math.min.apply(null, prices), hi = Math.max.apply(null, prices);
    var fmt = function (n) { return eur(n.toFixed(n % 1 ? 2 : 0)); };
    var price = !prices.length ? '' : (lo === hi ? fmt(lo) : T('ab ', 'from ') + fmt(lo));
    var text, ok = soforts.length > 0;
    if (soforts.length) {
      if (sel.length > 1 && soforts.length === sel.length) text = T('Alle deine Größen sofort lieferbar', 'All your sizes in stock now');
      else if (soforts.length <= 3) text = T('Größe ', 'Size ') + soforts.map(F.fmtLabel).join(', ') + T(' sofort lieferbar', ' in stock now');
      else text = soforts.length + T(' deiner Größen sofort lieferbar', ' of your sizes in stock now');
    } else if (present.length) {
      text = present.length <= 3 ? T('Größe ', 'Size ') + present.map(F.fmtLabel).join(', ') + T(' verfügbar', ' available') : present.length + T(' deiner Größen verfügbar', ' of your sizes available');
    } else text = '';
    return { text: text, ok: ok, price: price };
  }
  function matchLine(h, m, p) {
    h.querySelectorAll('.finder-szcost, .finder-avail, .finder-match').forEach(function (e) { e.remove(); });
    h.querySelectorAll('[data-finder-hid]').forEach(function (e) { e.hidden = false; e.removeAttribute('data-finder-hid'); });
    h.querySelectorAll('.h-verfuegbar[data-finder-orig]').forEach(function (e) { e.textContent = e.getAttribute('data-finder-orig'); e.removeAttribute('data-finder-orig'); });
    if (!(p.sizes.length || p.clothes.length)) return;
    var info = sizeInfo(m.vs, p);
    var priceEl = h.querySelector('price-list'), avEl = h.querySelector('.h-verfuegbar');
    var host = (priceEl && priceEl.parentNode) || h.querySelector('.product-card__info .v-stack') || h;
    var c = document.createElement('div');
    c.className = 'finder-szcost';
    c.textContent = info.price;
    if (priceEl) { priceEl.hidden = true; priceEl.setAttribute('data-finder-hid', '1'); }
    if (priceEl && priceEl.nextSibling) host.insertBefore(c, priceEl.nextSibling); else host.appendChild(c);
    /* Theme-Text unter dem Produkt („3 von 24 Größen sofort lieferbar“) bleibt unverändert, steht unter jedem Artikel */
    if (avEl) {
      if (!avEl.hasAttribute('data-finder-orig')) avEl.setAttribute('data-finder-orig', avEl.textContent);
      if (info.text) avEl.textContent = info.text;
      avEl.hidden = false;
      avEl.classList.add('finder-av-on');
      c.parentNode.insertBefore(avEl, c.nextSibling);
    }
  }

  var cardCache = {};
  function cardHtml(handle) {
    if (cardCache[handle]) return Promise.resolve(cardCache[handle]);
    return fetch(ROOT + 'products/' + encodeURIComponent(handle) + '?view=card', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); }).then(function (t) { return (cardCache[handle] = t); });
  }

  /** Trefferliste aus dem Index aufbauen: erste 24 sofort, Rest beim Scrollen */
  function build(list, matches, p) {
    var BATCH = 24, shownCount = 0;
    list.innerHTML = '';
    list.setAttribute('data-finder-built', '1');
    var sentinel = document.createElement('div');
    sentinel.className = 'finder-sentinel';
    sentinel.style.cssText = 'grid-column:1/-1;height:1px';
    function more() {
      var slice = matches.slice(shownCount, shownCount + BATCH);
      if (!slice.length) { sentinel.remove(); return; }
      shownCount += slice.length;
      var wraps = slice.map(function (m) {
        var w = document.createElement('div');
        w.className = 'finder-hit is-matched' + (p.sizes.length || p.clothes.length ? ' has-size' : '');
        w.setAttribute('data-built', '1');
        w.style.minHeight = '320px';
        list.insertBefore(w, sentinel);
        return w;
      });
      slice.forEach(function (m, i) {
        cardHtml(m.h).then(function (html) {
          var w = wraps[i];
          w.style.minHeight = '';
          w.innerHTML = html;
          matchLine(w, m, p);
          w.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
            a.setAttribute('href', a.getAttribute('href').split('?')[0] + '?variant=' + m.v.id);
          });
          lieferInfo();
        }).catch(function () { wraps[i].remove(); });
      });
      if (shownCount >= matches.length) sentinel.remove();
    }
    list.appendChild(sentinel);
    more();
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        if (es.some(function (e) { return e.isIntersecting; })) more();
      }, { rootMargin: '900px' });
      io.observe(sentinel);
    } else { while (shownCount < matches.length) more(); }
  }

  function chipRow(p) {
    var cs = chips(p);
    if (p.modell && p.modell.length) cs.push({ k: 'modell', t: p.modell.join(', ') });
    if (!cs.length) return '';
    return ' ' + cs.map(function (c) {
      return '<button type="button" class="finder-chip finder-chip--on' + (c.ok ? ' finder-chip--ok' : '') + '" data-drop-status="' + c.k + '">' + esc(c.t) + ' <span aria-hidden="true">×</span></button>';
    }).join('') + '<a class="finder-reset" data-finder-reset href="' + resetUrl() + '">' + T('Filter zurücksetzen', 'Reset filters') + '</a>';
  }

  /* ---------- Größen-Kacheln: nur Größen zeigen, die es in dieser Suche (mit Sofort/Preis) wirklich gibt ---------- */
  function updateTiles(idx, p) {
    var pool = {};
    idx.items.forEach(function (it) {
      F.parseVariants(it.v).forEach(function (v) {
        if (!v.avail) return;
        if (p.sofort && !v.sofort) return;
        if (p.pmin != null && v.price < p.pmin) return;
        if (p.pmax != null && v.price > p.pmax) return;
        pool[v.key] = (pool[v.key] || 0) + 1;
      });
    });
    /* Drittelgrößen (adidas „43 1/3“, „42 2/3“) stecken im Shop-Filter in den ganzen Gruppen: eigene Kacheln ergänzen */
    var need = {};
    Object.keys(pool).concat(p.sizes).forEach(function (k) { if (/^\d+\.(33|67)$/.test(k)) need[k] = 1; });
    document.querySelectorAll('.finder-tiles:not(.finder-tiles--cloth)').forEach(function (grid) {
      Object.keys(need).forEach(function (k) {
        var have = false;
        grid.querySelectorAll('.finder-tile').forEach(function (t) {
          var b = t.querySelector('.finder-tile__box');
          if (F.sizeKey(b.getAttribute('data-raw') || b.textContent) === k) have = true;
        });
        if (have) return;
        var lab = document.createElement('label');
        lab.className = 'finder-tile finder-tile--dyn';
        lab.innerHTML = '<input type="checkbox" autocomplete="off" class="finder-tile__input" name="filter.v.option.größe" value="' + F.fmtLabel(k) + ' EU"><span class="finder-tile__box" data-raw="' + F.fmtLabel(k) + '">' + F.fmtLabel(k) + '</span>';
        var before = null;
        grid.querySelectorAll('.finder-tile').forEach(function (t) {
          if (before) return;
          var b = t.querySelector('.finder-tile__box');
          if (parseFloat(F.sizeKey(b.getAttribute('data-raw') || b.textContent)) > parseFloat(k)) before = t;
        });
        grid.insertBefore(lab, before);
      });
    });
    document.querySelectorAll('.finder-tiles').forEach(function (grid) {
      var seen = {}, any = false;
      grid.querySelectorAll('.finder-tile').forEach(function (t) {
        var box = t.querySelector('.finder-tile__box'), inp = t.querySelector('input');
        var raw = box.getAttribute('data-raw') || box.textContent;
        box.setAttribute('data-raw', raw);
        var key = F.sizeKey(raw);
        if (/^\d+(\.\d+)?$/.test(key)) box.textContent = F.fmtLabel(key);
        else if (/^[A-Z0-9\/]{1,6}$/.test(key)) box.textContent = key;   // „27.5 - Sofort verfügbar!“ → „27.5“, „One Size“ → „OS“
        var ok = (pool[key] > 0 || inp.checked) && !seen[key];
        if (ok) { seen[key] = 1; any = true; }
        t.hidden = !ok;
      });
      grid.hidden = !any;
    });
    /* Buchstabengrößen in Konfektionsreihenfolge: XXS, XS, S, M, L, XL, XXL …, OS zuletzt */
    var RANK = { XXXS: 0, '3XS': 0, XXS: 1, '2XS': 1, XS: 2, S: 3, M: 4, L: 5, XL: 6, XXL: 7, '2XL': 7, XXXL: 8, '3XL': 8, XXXXL: 9, '4XL': 9, '5XL': 10, OS: 99 };
    function rankOf(k) {
      k = String(k).toUpperCase();
      if (RANK[k] != null) return RANK[k];
      var parts = k.split('/');
      if (parts.length > 1 && RANK[parts[0]] != null) return RANK[parts[0]] + 0.5;
      return 50;
    }
    document.querySelectorAll('.finder-tiles--cloth').forEach(function (grid) {
      var tiles = Array.prototype.slice.call(grid.querySelectorAll('.finder-tile'));
      var sorted = tiles.slice().sort(function (a, b) {
        var ka = F.sizeKey(a.querySelector('.finder-tile__box').getAttribute('data-raw') || a.textContent);
        var kb = F.sizeKey(b.querySelector('.finder-tile__box').getAttribute('data-raw') || b.textContent);
        return rankOf(ka) - rankOf(kb);
      });
      var same = sorted.every(function (t, i) { return t === tiles[i]; });
      if (!same) sorted.forEach(function (t) { grid.appendChild(t); });
    });
    document.querySelectorAll('.finder-kids').forEach(function (d) {
      d.hidden = !d.querySelector('.finder-tile:not([hidden])');
    });
  }
  function relabelApply(n) {
    document.querySelectorAll('.facets-drawer__floating-apply button').forEach(function (b) {
      b.textContent = n === 0 ? T('Keine Treffer – Filter lockern', 'No results – loosen filters') : T(n + ' Treffer anzeigen', 'Show ' + n + ' results');
      b.setAttribute('data-finder-apply', '1');
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-finder-apply]');
    if (!b) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var d = b.closest('facet-drawer, .facets-drawer') || document.querySelector('facet-drawer');
    var c = d && d.querySelector('[is="close-button"], button[aria-label*="chließ"], button[aria-label*="lose"]');
    if (c) c.click(); else if (d) { d.removeAttribute('open'); }
    window.scrollTo({ top: 0 });
  }, true);

  var applying = false;
  function apply() {
    var s = F.fromLocation(location), p = s.parsed;
    var list = document.querySelector('product-list');
    var status = statusEl();
    var pag = document.querySelector('.collection__pagination');
    renderReset();
    lieferInfo();
    loadIndex().then(function (idx) { updateTiles(idx, p); }).catch(function () {});
    var tt = ((p.vendor ? p.vendor + ' ' : '') + p.words.join(' ')).trim();
    if (tt && onSearchPage()) document.title = T('Suche: ', 'Search: ') + tt + ' – Shade Studios';
    if (!list) return;
    if (!activeFilter(p)) {
      if (pag) pag.hidden = false;
      if (status) status.textContent = s.fallback ? T('Keine exakte Übereinstimmung — das sind ähnliche Treffer.', 'No exact match — these are similar results.') : '';
      modelPool = null;
      return;
    }
    var sig = location.search;
    if (built === sig && list.getAttribute('data-finder-built') === '1') return;
    if (pag) pag.hidden = true;
    var my = ++token;
    if (status) status.textContent = T('Prüfe Treffer …', 'Checking results …');
    loadIndex().then(function (idx) {
      if (my !== token) return;
      var varFilter = p.sizes.length || p.clothes.length || p.sofort || p.pmin != null || p.pmax != null;
      var pool = {}, matches = [];
      idx.items.forEach(function (it) {
        var vs = F.parseVariants(it.v);
        var hit = varFilter ? F.bestMatch(vs, p) : vs.filter(function (v) { return v.avail; });
        if (!hit.length) return;
        if (it.m) pool[it.m] = (pool[it.m] || 0) + 1;
        if (!F.productMatches({ color: it.c, model: it.m }, p)) return;
        matches.push({ h: it.h, v: hit[0], vs: vs });
      });
      modelPool = pool;
      var cur = document.querySelector('product-list') || list;
      if (matches.length === 0) {
        cur.innerHTML = '';
        cur.setAttribute('data-finder-built', '1');
        relabelApply(0);
        setH1(0, p, false);
        if (status) {
          status.innerHTML = '<strong>' + T('Nichts gefunden, das alles erfüllt.', 'Nothing matches all of this.') + '</strong> ' + T('Lockern: ', 'Loosen: ') +
            chips(p).map(function (c) { return '<button type="button" class="finder-chip" data-drop-status="' + c.k + '">' + T('ohne ', 'without ') + esc(c.t) + '</button>'; }).join('') +
            (hasFilterParams() ? '<a class="finder-chip" data-finder-reset href="' + resetUrl() + '">' + T('Alle Filter zurücksetzen', 'Reset all filters') + '</a>' : '');
        }
      } else {
        build(cur, matches, p);
        relabelApply(matches.length);
        setH1(matches.length, p, false);
        if (status) status.innerHTML = '<strong>' + matches.length + T(' passende Treffer', ' matching results') + '</strong>' + (onSearchPage() && idx.total >= 1000 ? T(' (Shopify zeigt max. 1.000 je Suche)', ' (Shopify shows max. 1,000 per search)') : '') + chipRow(p);
      }
      built = sig;
      renderExtra();
    }).catch(function () {
      if (my !== token) return;
      if (pag) pag.hidden = false;
      if (status) status.textContent = '';
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-drop-status]');
    if (b) {
      var k = b.getAttribute('data-drop-status'), sp = new URLSearchParams(location.search);
      if (k === 'sizes' || k === 'clothes') sp.delete('filter.v.option.größe');
      if (k === 'sofort') sp.delete('sofort');
      if (k === 'preis') { sp.delete('filter.v.price.gte'); sp.delete('filter.v.price.lte'); }
      if (k === 'modell') sp.delete('modell');
      history.replaceState(null, '', location.pathname + '?' + sp.toString());
      syncInputs(); renderPriceFromUrl();
      window.dispatchEvent(new Event('finder:changed'));
    }
  });

  function emptyFallback() {
    var s = F.fromLocation(location);
    var e = document.querySelector('[data-finder-empty]');
    if (!onSearchPage() || !e) return;
    var p = s.parsed;
    if (s.fallback || !(p.words.length || p.vendor)) { e.setAttribute('data-ready', ''); return; }
    go({ parsed: p, fallback: true, sort: s.sort });
  }

  var obs;
  function init() {
    wireInputs();
    if (!onFinderPage()) return;
    function carry() {
      var sp = new URLSearchParams(location.search);
      document.querySelectorAll('form#facet-form, form[is="facet-form"]').forEach(function (f) {
        ['fq', 'fb'].forEach(function (k) {
          var v = sp.get(k);
          var ex = f.querySelector('input[data-finder-carry="' + k + '"]');
          if (v == null) { if (ex) ex.remove(); return; }
          if (!ex) { ex = document.createElement('input'); ex.type = 'hidden'; ex.name = k; ex.setAttribute('data-finder-carry', k); f.appendChild(ex); }
          ex.value = v;
        });
        var sw = f.querySelector('input[data-finder-sofort]');
        if (sw) sw.checked = sp.get('sofort') === '1';
        var q = f.querySelector('input[name="q"]');
        if (q && sp.get('q')) q.value = sp.get('q');
      });
    }
    var target = document.querySelector('main') || document.body;
    var busy = false;
    function watch() { obs.observe(target, { childList: true, subtree: true }); }
    function pass() {
      busy = true; obs.disconnect();
      try { carry(); wireInputs(); initPrice(); wireToggle(); apply(); renderExtra(); }
      finally { obs.takeRecords(); watch(); busy = false; }
    }
    obs = new MutationObserver(function () {
      if (busy) return;
      clearTimeout(init._t);
      init._t = setTimeout(pass, 120);
    });
    emptyFallback();
    pass();
    loadIndex().catch(function () {});   // Index schon vorab holen → erster Klick sofort
    window.addEventListener('finder:changed', function () { built = ''; pass(); });
    window.addEventListener('popstate', function () { setTimeout(pass, 50); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // Header-Suche wird erst beim Öffnen sichtbar → nachziehen
  document.addEventListener('click', function () { setTimeout(wireInputs, 50); });
})();
